<template>
  <div v-if="overridecount" class="d-flex align-center">
    <CardBadge color="primary" :count="overridecount" :donthide="true" />
  </div>
  <div v-else-if="fulllist && fulllist.length > 0" class="d-flex align-center">
    <CardBadge v-if="isReduced" :color="'tertiary'" :count="reducedlist.length" :donthide="true" />

    <div v-if="isReduced" v-text="'/'" class="mx-1" />

    <CardBadge v-if="!isReduced" :color="isReduced ? 'disabled' : 'primary'" :count="fulllist.length" :donthide="true" />
    <div v-else v-text="fulllist.length" />

    <!--
    <div v-text="$t(objectName)"
         class="ml-1" />
    -->

  </div>
</template>


<script>
import CardBadge from "@/components/Buttons/CardBadge.vue";

export default {
  name: "DifferenceIndicator",
  props: {
    overridecount: Number,
    reducedlist: Array,
    fulllist: Array,
    objectName: String,
  },
  components: { CardBadge },
  mixins: [],

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {
    isReduced() {

      return this.reducedlist && this.reducedlist.length < this.fulllist.length;
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>